import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  Avatar,
  Divider,
  List,
  ListItemAvatar,
  ListItemText,
  Link,
} from "@mui/material";
import ReactECharts from "echarts-for-react";
import AvatarImage from "../../../../images/Avatar.svg";
import {
  getprojectsFiltering,
  getAllCapabilities,
} from "../../../../services/webServices.js";

const ProjectsLeaderBoard = () => {
  const [projectCapability, setProjectCapability] = useState("");
  const [projectFromDate, setProjectFromDate] = useState("");
  const [projectToDate, setProjectToDate] = useState("");
  const [topProjects, setTopProjects] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [capabilities, setCapabilities] = useState([]);

  const fetchFilteredProjects = async () => {
    try {
      const response = await getprojectsFiltering({
        capability_name: projectCapability,
        from_date: projectFromDate,
        to_date: projectToDate,
      });
      const sorted = [...response.data.data]
        .sort((a, b) => b.tokens_used - a.tokens_used)
        .slice(0, 16);
      setTopProjects(sorted);
    } catch (error) {
      console.error("Failed to fetch project leaderboard:", error);
    }
  };
  useEffect(() => {
    fetchFilteredProjects();
  }, [projectCapability, projectFromDate, projectToDate]);

  const sortedTop3 = [...topProjects.slice(0, 3)].sort(
    (a, b) => b.tokens_used - a.tokens_used
  );
  useEffect(() => {
    const getCapabilitiesForDropDown = async () => {
      try {
        const response = await getAllCapabilities();
        setCapabilities(response.data);
      } catch (error) {
        console.error("Error fetching capabilities:", error);
      }
    };

    getCapabilitiesForDropDown();
  }, []);

  const chartOptions = {
    xAxis: { type: "category", show: false },
    yAxis: { type: "value", show: false },
    grid: { left: 0, right: 0, top: 0, bottom: 0 },
    series: [
      {
        data: [
          sortedTop3[1]?.tokens_used,
          sortedTop3[0]?.tokens_used,
          sortedTop3[2]?.tokens_used,
        ],
        type: "bar",
        itemStyle: {
          color: {
            type: "radial",
            x: 1,
            y: 2.5,
            r: 5,
            colorStops: [
              { offset: 0, color: "#DCE1F8" },
              { offset: 0.5, color: "#E9EDFB" },
              { offset: 1, color: "#C3C8E8" },
            ],
          },
          borderRadius: [10, 10, 0, 0],
        },
      },
    ],
  };
  return (
    <Card sx={{ maxWidth: "400px", minHeight: "625px", margin: "auto", p: 1 }}>
      <CardContent>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "16px", color: "grey" }}
        >
          Projects Leaderboard
        </Typography>

        <FormControl
          sx={{
            mt: -4,
            ml: { xs: 0, sm: 10, md: 27 },
            minWidth: 120,
          }}
          size="small"
        >
          <InputLabel id="capability-name-label">Capability</InputLabel>
          <Select
            labelId="capability-name-label"
            value={projectCapability}
            onChange={(e) => setProjectCapability(e.target.value)}
            label="Capability"
          >
            {capabilities.map((item, index) => (
              <MenuItem key={index} value={item.capability_name}>
                {item.capability_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 2,
          }}
        >
          <TextField
            label="From"
            variant="outlined"
            type="date"
            value={projectFromDate}
            onChange={(e) => setProjectFromDate(e.target.value)}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            sx={{ width: "43.5%" }}
          />
          <TextField
            label="To"
            variant="outlined"
            type="date"
            value={projectToDate}
            onChange={(e) => setProjectToDate(e.target.value)}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            inputProps={{ min: projectFromDate || "" }}
            disabled={!projectFromDate}
            sx={{ width: "42.5%" }}
          />
        </Box>

        <Divider
          sx={{
            marginTop: 2.5,
            marginBottom: 1,
            borderColor: "#eee",
            width: "110%", // Increase width beyond the container
            marginLeft: "-5%", // Extend beyond the left
            marginRight: "-5%",
          }}
        />

        <Box
          display="flex"
          justifyContent="space-around"
          alignItems="flex-end"
          py={2}
        >
          {[topProjects[1], topProjects[0], topProjects[2]]
            .filter(Boolean)
            .map((proj, index) => (
              <Box
                key={proj.Project_Name}
                textAlign="center"
                sx={{
                  transform:
                    index === 1
                      ? "translateY(-10px)"
                      : index === 0
                      ? "translateY(10px)"
                      : "translateY(20px)",
                }}
              >
                <Avatar src={AvatarImage} sx={{ width: 50, height: 80 }} />
                <Typography fontWeight="bold" fontSize={14}>
                  {proj.Project_Name}
                </Typography>
                <Typography variant="caption" sx={{ color: "#9C9C9C" }}>
                  {Math.floor(proj.tokens_used / 100)}pt
                </Typography>
              </Box>
            ))}
        </Box>

        <ReactECharts option={chartOptions} style={{ height: 90 }} />

        <List>
          {topProjects.slice(3, 6).map((proj, index) => (
            <Box
              key={proj.Project_Name}
              sx={{
                padding: 1.5,
                display: "flex",
                alignItems: "center",
                borderRadius: 2,

                border: "1px ",
                marginBottom: 1, // Adds space between boxes
                // backgroundColor: "#D9D9D9",
                height: 18, // Decreased height
                backgroundColor: "#f9f9f9", // Light background color
                boxShadow: "2px 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <Typography sx={{ minWidth: 30 }}>{index + 4}.</Typography>
              <ListItemAvatar sx={{ marginRight: 1 }}>
                <Avatar src={AvatarImage} sx={{ width: 30, height: 40 }} />
              </ListItemAvatar>
              <ListItemText
                primary={proj.Project_Name}
                slotProps={{ primary: { typography: { fontWeight: "bold" } } }}
              />
              <Typography
                fontWeight="bold"
                sx={{ marginLeft: "auto", color: "#9C9C9C" }}
              >
                {Math.floor(proj.tokens_used / 100)}pt
              </Typography>
            </Box>
          ))}

          {showMore &&
            topProjects.slice(6, 16).map((proj, index) => (
              <Box
                key={proj.Project_Name}
                sx={{
                  padding: 1.5,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 2,
                  height: 20,
                  backgroundColor: "#f9f9f9",
                  boxShadow: "2px 2px 6px rgba(0,0,0,0.1)",
                  marginBottom: 1,
                }}
              >
                <Typography sx={{ minWidth: 30 }}>{index + 7}.</Typography>
                <ListItemAvatar sx={{ marginRight: 1 }}>
                  <Avatar src={AvatarImage} sx={{ width: 30, height: 40 }} />
                </ListItemAvatar>
                <ListItemText
                  primary={proj.Project_Name}
                  slotProps={{
                    primary: { typography: { fontWeight: "bold" } },
                  }}
                />
                <Typography
                  fontWeight="bold"
                  sx={{ marginLeft: "auto", color: "#9C9C9C" }}
                >
                  {Math.floor(proj.tokens_used / 100)}pt
                </Typography>
              </Box>
            ))}
        </List>

        <Divider sx={{ marginBottom: 1 }} />

        <Box textAlign="center" mt={2}>
          <Link
            href="#"
            underline="hover"
            color="#0094FB"
            fontWeight="bold"
            fontSize={14}
            onClick={(e) => {
              e.preventDefault();
              setShowMore(!showMore);
            }}
          >
            {showMore ? "View Less" : "View More"}
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProjectsLeaderBoard;
